import React from 'react';

const SampleLogo = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1972 38.8298H39.9994V30.1611L32.1221 19.9687L40 9.48565V1.16943L25.2658 1.18338L17.6873 10.8674L21.1399 15.4327L28.0214 6.81588H35.0656L24.9242 19.9687L34.9653 33.1214H28.1212L21.1429 24.5295L17.6873 29.1564L25.1972 38.8298ZM0.0764067 33.1214H7.36377L17.6873 20.0052L7.22599 6.81588H4.04495e-05L10.382 20.0153L0.0764067 33.1214Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="20"
          y1="1.16943"
          x2="20"
          y2="38.8298"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5557FE" />
          <stop offset="1" stopColor="#9555FE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SampleLogo;
